import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import RealisticBackground from "./components/RealisticBackground";
import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import AboutSection from "./components/AboutSection";
import TechStackSection from "./components/TechStackSection";
import TerrariumSection from "./components/TerrariumSection";
import NovelsSection from "./components/NovelsSection";
import KTMSection from "./components/KTMSection";
import AISection from "./components/AISection";
import InspiredBySection from "./components/InspiredBySection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";

const Portfolio = () => {
  return (
    <div className="min-h-screen relative overflow-x-hidden">
      {/* Photorealistic Animated Background */}
      <RealisticBackground />
      
      {/* Fixed Header */}
      <Header />
      
      {/* Content Layer */}
      <main className="relative" style={{ zIndex: 10 }}>
        {/* Hero */}
        <HeroSection />
        
        {/* About */}
        <div id="about">
          <AboutSection />
        </div>
        
        {/* Tech Stack */}
        <div id="stack">
          <TechStackSection />
        </div>
        
        {/* Hobbies - Deep sections */}
        <div id="hobbies">
          <TerrariumSection />
          <NovelsSection />
          <KTMSection />
          <AISection />
        </div>
        
        {/* Inspired By */}
        <div id="inspired">
          <InspiredBySection />
        </div>
        
        {/* Contact */}
        <div id="contact">
          <ContactSection />
        </div>
        
        {/* Footer */}
        <Footer />
      </main>
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Portfolio />} />
          <Route path="*" element={<Portfolio />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
